import {config} from "../config";

class ShortenerService {

  async shorten(url: string): Promise<any> {
    let response = await fetch(`${config.shortenerUrl}/api/shorten`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({url: url})
      });
      return await response.json();
  }
}

export const shortenerSerivce = new ShortenerService();